import { Alert } from "@/components/atoms/Alert";
import Autocomplete from "@/components/atoms/Autocomplete";
import { Box } from "@/components/atoms/Box";
import { useSetting } from "@/context";
import { useEffect } from "react";

export const ShowComponent = () => {
  const setting = useSetting();
  useEffect(() => {
    setting.updateTitleHeader("ダッシュボード");
  }, [setting]);

  return (
    <>
      <div style={{ width: "100%", marginBottom: 50 }}>Show component</div>
      <div style={{ width: "100%", marginBottom: 50 }}>
        <label>Alert</label>
        <Alert />
      </div>
      <div style={{ width: "100%", marginBottom: 50 }}>
        <label>Autocomplete</label>
        <Autocomplete
          options={[{ id: "a", label: "b" }]}
          renderInput={() => <div>abc</div>}
        />
      </div>
      <div style={{ width: "100%", marginBottom: 50 }}>
        <label>Box</label>
        <Box />
      </div>
    </>
  );
};
